module.exports = __webpack_public_path__ + "img/reward_cash.png";